import dayjs from "dayjs";
import { Subscription } from "../model/Subscription";

export class SubscriptionPrice {
  monthly: number = 0;
  yearly: number = 0;
  monthlyForYear: number = 0;
  discountRate: number = 0;
}

const priceMap: { [key: string]: SubscriptionPrice; } = {
  'free': { monthly: 0, yearly: 0, monthlyForYear: 0, discountRate: 0 },
  'lite': { monthly: 780, yearly: 8424, monthlyForYear: 702, discountRate: 21 },
  'standard': { monthly: 3500, yearly: 33600, monthlyForYear: 2800, discountRate: 20 },
};

const descriptionMap: { [key: string]: any; } = {
  'free': '\n・1日あたりの生成数の上限 4 まで\n・広告非表示オプション なし\n・同時画像生成数 1 まで\n・生成画像の保存期間 30 日間\n・詳細画像設定機能 なし',
  'lite': '・1ヶ月あたりの生成数の上限 600 まで\n・広告非表示オプション あり\n・同時画像生成数 4 まで\n・生成画像の保存期間 90 日間\n・詳細画像設定機能 あり',
  'standard': '・1ヶ月あたりの生成数の上限 3,000 まで\n・広告非表示オプション あり\n・同時画像生成数 4 まで\n・生成画像の保存期間 無制限\n・詳細画像設定機能 あり',
};

const summaryMap: { [key: string]: any; } = {
  'free': 'トライアルに最適な無料プラン。1日の生成回数制限内で楽しめます。',
  'lite': '1日の生成回数制限を解除して画像生成を楽しみたい方向け。基本機能が全て利用可能です。',
  'standard': 'DropAI最上位プラン。制限を気にせずサービスを利用したい方向け。全ての機能をフルで使えます。',
};

const planNameMap: { [key: string]: any; } = {
  'free': 'Free',
  'lite': 'Lite',
  'standard': 'Standard',
};

export function getPlanPrice(planId: string, span: string) : SubscriptionPrice {
  return priceMap[planId] || { monthly: 0, yearly: 0 };
}

export function getPlanNameBySubscription(subscription: Subscription | undefined) : string {
  if (subscription === undefined) {
    return '---';
  }

  if(subscription.internalProductId === 'free') {
    return 'Free';
  }
  if(subscription.internalProductId.startsWith('lite')) {
    return 'Lite';
  }
  if(subscription.internalProductId.startsWith('standard')) {
    return 'Standard';
  }
  return 'invalid plan';
}

export function getPlanName(planId: string) : string {
  return planNameMap[planId] || '';
}

export function getPlanPriceText(subscription: Subscription | undefined) : string {
  if (subscription === undefined) {
    return '---';
  }

  if(subscription.internalProductId === 'free') {
    return '無料';
  }
  if(subscription.internalProductId.startsWith('lite')) {
    return '780円 / 月';
  }
  if(subscription.internalProductId.startsWith('standard')) {
    return '3,500円 / 月 ';
  }
  return "未定";
}

export function getExpiryText(subscription: Subscription | undefined) : string {
  if (subscription === undefined || subscription.internalProductId === 'free') {
    return '---';
  }

  return dayjs(subscription?.currentPeriodEnd).format('YYYY/MM/DD HH:mm');
}

export function getRnewwalType(subscription: Subscription | undefined) : string {
  if (subscription === undefined || subscription.internalProductId === 'free') {
    return '---';
  }

  if(subscription.internalProductId.endsWith('month')) {
    return '月間契約';
  }
  if(subscription.internalProductId.endsWith('year')) {
    return '年間契約';
  }
  return '---';
}

export function getPlanDescription(planId: string) : string {
  return descriptionMap[planId] || '';
}

export function getPlanSummary(planId: string) : string {
  return summaryMap[planId] || '';
}

export function getNextPlanId(subscription: Subscription | undefined) : string {
  if(subscription === undefined || subscription.internalProductId === 'free') {
    return 'lite';
  }
  if(subscription.internalProductId.startsWith('lite')) {
    return 'standard';
  }
  return '';
}

export function getTransactionItemName(itemName: string) : string {
  if(itemName.startsWith('credit_')) {
    const amount = itemName.split('_')[1];
    return `生成回数 ${amount} 回`;
  }

  return getPlanName(itemName) + ' プラン';
}
